angular.module("Finance")
    .controller("userSettingsController", [
        "$scope", "$language", "$state",
        function($scope, $language, $state) {

            $scope.language = $language.get();
            $scope.availableLanguages = $language.availableLanguages;

            $scope.apply = function() {
                $language.set($scope.language);
                $scope.$close();
                $state.go($state.current, {}, { reload: true });
            };
        }
    ]);